<template>
  <div class="frequency-and-duration w-full">
    <table class="w-full border-collapse text-xs">
      <thead>
        <tr>
          <th class="border p-1">Häufigkeit</th>
          <th class="border p-1" colspan="2">Dauer</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="border p-1">
            <select 
              v-model="item.frequency" 
              @change="updateItem(index, 'frequency', $event.target.value)"
              class="w-full p-1 h-6"
            >
              <option value="">Bitte wählen</option>
              <option value="1x täglich">1x täglich</option>
              <option value="2x täglich">2x täglich</option>
              <option value="3x täglich">3x täglich</option>
              <option value="1x wöchentlich">1x wöchentlich</option>
              <option value="2x wöchentlich">2x wöchentlich</option>
              <option value="1x monatlich">1x monatlich</option>
              <option value="2x monatlich">2x monatlich</option>
            </select>
          </td>
          <td class="border p-1">
            <input 
              v-model="item.from" 
              @input="updateItem(index, 'from', $event.target.value)"
              type="date" 
              class="w-full h-6 p-1" 
            />
          </td>
          <td class="border p-1">
            <input 
              v-model="item.to" 
              @input="updateItem(index, 'to', $event.target.value)"
              type="date" 
              class="w-full h-6 p-1" 
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'FrequencyAndDuration',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  emits: ['update'],
  methods: {
    updateItem(index, field, value) {
      const updatedItem = { ...this.items[index], [field]: value };
      this.$emit('update', { index, item: updatedItem });
    }
  }
}
</script>

<style scoped>
.frequency-and-duration {
  min-width: 150px; /* Reduzierte Mindestbreite */
}
select, input[type="date"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
}

select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cpath d='M0 2l4 4 4-4z' fill='%23000000'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  padding-right: 1.5rem;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  display: block;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'%3E%3Cpath d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z' fill='%23000000'/%3E%3C/svg%3E") no-repeat;
  width: 16px;
  height: 16px;
  border-width: thin;
}
</style>